module.exports = __webpack_public_path__ + "img/1-2.51da8ec5.png";